import { SearchPillComponent } from '@app/shared/components/filter-bar/search-pill.component';
import { Component, Inject,OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { LoggerService } from '@app/logger/logger.service';

import { ProcedureService } from '@app/shared/services/entities/procedure.service';
import { SpecialtyService } from '@app/shared/services/entities/specialty.service';
import { ContractsService } from '@app/shared/services/entities/contracts.service';
import { CustomMessageService } from '@app/shared/components/custom-message/custom-message.service';
import { CustomSnackBarService } from '@app/shared/components/custom-snack-bar/custom-snack-bar.service';
import { CustomDialogComponent } from '@app/custom-material/custom-dialog/custom-dialog.component';
import { DialogData } from '@app/shared/models/custom-dialog.model';
import { UploadFileDialogService } from '@app/shared/custom-dialogs/upload-file-dialog/upload-file-dialog.service';
import { SimpleExcelUploadService } from '@app/shared/services/simple-excel-upload.service';
import { ExcelUploaderConfig } from '@app/shared/models/simple-excel-upload.model';
import { EventEmitedModel, TableMenuModel, TableStructureModel } from '@app/shared/models/table.model';
import { SimpleExcelService } from '@app/shared/services/simple-excel.service';
import { ProcedureRequirementsComponent } from './procedure-requirements/procedure-requirements.component';


import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@app/material.module';
const log = new LoggerService('CONTRACT-PROCEDURES COMPONENT');
@Component({
  standalone: true,
  imports: [SearchPillComponent, 
    FormsModule,
    ReactiveFormsModule,
    MaterialModule
],
  selector: 'app-contract-procedure',
  templateUrl: './contract-procedure.component.html',
  styleUrls: ['./contract-procedure.component.scss']
})
export class ContractProcedureComponent implements OnInit {

  public structure: TableStructureModel[] = [
    {columnKey: "name", columnName: "Nombre", type: "string"},
    {columnKey: "itemNumber", columnName: "Código", type: "string"},
    {columnKey: "price", columnName: "Precio", type: "currency"},
    {columnKey: "specialty_name", columnName: "Especialidad", type: "string"},
  ];
  
  public menu: TableMenuModel[] = [
    {icon: "inventory", action: "requirement", color: "primary", display:"Requerimientos"},
    {icon: "delete", action: "delete", color: "warn", display:"Quitar"}
  ];
  
  // Datos locales del contrato
  public contractData: any;
  public contractProcedures: any[] = []; // Procedimientos asignados al contrato
  public procedureList: any[] = []; // Procedimientos disponibles para agregar
  public procedureObject: { [key: string]: any } = {};
  public specialtyList:any[] = [];
  public specialtyObject: { [key: string]: any } = {};

  catalogue: string = '';
  cat:string = '';
  keys: any[] = [];
  keyNames: any[] = [];
  inputs: any[] =  [];

  public dataSource = new MatTableDataSource();
  public dataService;
  public dataList: any[] = [];
  public userCustomParams: { [key: string]: any } = {};
  public permissions: { [key: string]: any } = {};
  public createBtn = false;

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  
  public value = 0;
  public hasData = false;

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<ContractProcedureComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private customMessageService: CustomMessageService,
    private customSnackBar: CustomSnackBarService,
    private uploadFileDialog: UploadFileDialogService,
    private simpleExcelUpload: SimpleExcelUploadService,
    private simpleExcel: SimpleExcelService,
    private contractsService: ContractsService,
    private procedureService: ProcedureService,
    private specialtyService: SpecialtyService
  ) { }

  async ngOnInit() {
    log.debug(this.data)
    this.contractData = { ...this.data['contract'] };
    this.userCustomParams = { ...this.data['userCustomParams'] };
    this.permissions = { ...this.data['permissions'] };
    await this.getEntityData();
  }

     /*** @description Filtro*/
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value
      .replace(/&|<|>|"|'/g, match => ({'&': '&amp;','<': '&lt;','>': '&gt;','"': '&quot;',"'": '&#39;'}[match]!)) //Sanitizar caracteres especiales en HTML
      .replace(/[^a-zA-Z0-9áéíóú-\s]/g, '')     // Solo permitir caracteres alfannuméricos y espacios
      .trim();
    this.dataSource.filter = filterValue.trim().toLowerCase();
    this.paginator.length = this.dataSource.filteredData.length;
    this.dataSource.paginator = this.paginator;
  }

  async getEntityData(){
    await this.getEntityDataProcedures();
    await this.getEntityDataSpecialties();
    this.catalogue =  'Procedimientos de contrato';
    this.cat = 'procedimiento';
    this.keys = ['name', 'itemNumber','price', 'specialty', 'more'];
    this.keyNames = ['Nombre', 'Codigo','Precio', 'Especialidad', 'Más']
    this.inputs = [{'name': 'id','displayName': 'Nombre','type': 'select','options': this.procedureList,'required': true},
                  {'name': 'itemNumber','displayName': 'Codigo','type': 'text','required': true},
                  {'name': 'price','displayName': 'Precio','type': 'number','required': true},
                  {'name': 'specialty','displayName': 'Especialidad','type': 'select','options': this.specialtyList,'required': true}]
    this.loadContractProcedures();
  }

    /**
   * @description Buscar procedimientos
   */
   async getEntityDataProcedures() {
    try{
      const apiResponse = await this.procedureService.search({searchType:'default',condition:{deleted:false}})
      if (apiResponse.state === 'success') {
        this.procedureList = apiResponse.data;
        this.procedureObject = this.procedureList.reduce(function (r, a) {
          r[a['id']] = r[a['id']] || [];
          r[a['id']] = a['name'];
          return r;
        }, Object.create(null));
      }
    }catch(err){
      throw err;
    }
  }

      /**
   * @description Buscar especialidades
   */
   async getEntityDataSpecialties() {
    try{
      if (this.contractData['specialties'] && this.contractData['specialties'].length > 0) {
        this.specialtyList = [...this.contractData['specialties']];
        this.specialtyObject = this.specialtyList.reduce(function (r, a) {
          r[a['id']] = r[a['id']] || [];
          r[a['id']] = a['name'];
          return r;
        }, Object.create(null));
      } else {
        const apiResponse = await this.specialtyService.search({searchType:'default',condition:{deleted:false}})
        if (apiResponse.state === 'success') {
          this.specialtyList = apiResponse.data;
          this.specialtyObject = this.specialtyList.reduce(function (r, a) {
            r[a['id']] = r[a['id']] || [];
            r[a['id']] = a['name'];
            return r;
          }, Object.create(null));
        }
      }
    }catch(err){
      throw err;
    }
  }

  /**@description Cargar procedimientos del contrato */
  loadContractProcedures() {
    if (this.contractData['procedures'] && this.contractData['procedures'].length > 0) {
      this.dataList = [...this.contractData['procedures']];
      console.log('[getEntityData] dataList', this.dataList)
      this.dataList.forEach(element =>{
        element._specialty = this.specialtyObject[element.specialty] ?? 'N/A';
      })
      this.hasData = true;
    }  else {
      this.dataList = [];
      this.hasData = false;
    }
    this.dataSource = new MatTableDataSource(this.dataList);
    if (this.paginator) {
      this.dataSource.paginator = this.paginator;
    }
    this.createBtn = true;
  }

  openDynamicDialog(type: string, element?: any) {
    console.log('[openDynamicDialog] this.inputs', this.inputs)
    let forms = this.inputs.map(({name, displayName, type, required, options}) => ({
      key: name,
      label: displayName,
      type: type,
      required: required,
      ...(options && { options: options.map(({ id, name }) => ({ label: name, value: id })) }), //Si el input incluye opciones, obtener su label y value
      ...(element?.[name] !== undefined && { value: element[name] }), //Si se manda un elemento (cuando type = update), enviar el valor actual
    }))
    console.log('[openDynamicDialog] forms', forms)
    
    let config: DialogData = {
      title: `Nuevo ${this.cat}`,
      fields: forms
    };

    const dialogRef = this.dialog.open(CustomDialogComponent, {
      data: config,
      width: '600px'
    });

    dialogRef.afterClosed().subscribe(async result => {
      if (result) {
        console.log('Datos del form:', result);
        if(type === 'create') await this.createEntityData(result);
        else if(type === 'update'){
          result['id'] = element['id'];
          result['id'] = element['id'];
          await this.updateEntityData(result);
        }
      }
    });
  }

  /**@description Crea nuevo objeto de la entidad */
  async createEntityData(record: any){
    try{
      const createConfirm = await this.customMessageService.open({
        title: 'Cuidado',
        type: 'warning',
        message: `¿Seguro que quieres crear el registro <b>${this.procedureObject[record.id]}</b>?`,
        acceptBtn: true,
        dismissBtn: true,
      });
  
      if (createConfirm) {
        this.customMessageService.close();
        record['name']=this.procedureObject[record.id]
        record['requirements']=[]
        this.dataList = [...this.dataList,record];
        console.log('[getEntityData] specialtyObject', this.specialtyObject)
        this.dataList.forEach(element =>{
          element._specialty = this.specialtyObject[element.specialty] ?? 'N/A';
        })
        this.hasData = !!this.dataList && this.dataList.length > 0;
        console.log('[getEntityData] dataList', this.dataList)
        this.dataSource = new MatTableDataSource(this.dataList);
        if (this.paginator) {
          this.dataSource.paginator = this.paginator;
        }
      }
    }catch(err){
      this.customMessageService.close();
      await this.customMessageService.open({
        title: 'Error', 
        type: 'error', 
        message: String(err), 
        dismissBtn: true 
      });
    }
  }
  
   /**@description Actualiza objeto de la entidad */
  async updateEntityData(record: any){
    try{
      const updateConfirm = await this.customMessageService.open({
        title: 'Cuidado',
        type: 'warning',
        message: `¿Seguro que quieres editar el registro <b>${record.name}</b>?`,
        acceptBtn: true,
        dismissBtn: true,
      });
  
      if (updateConfirm) {
        this.customMessageService.close();
        const recordIndex = this.dataList.findIndex(item => item.id === record.id);
        if (recordIndex !== -1) {
          // Reemplazar el registro existente
          this.dataList[recordIndex] = record[0];
        }
        this.dataList.forEach(element =>{
          element._specialty = this.specialtyObject[element.specialty] ?? 'N/A';
        })
        this.hasData = !!this.dataList && this.dataList.length > 0;
        console.log('[getEntityData] dataList', this.dataList)
        this.dataSource = new MatTableDataSource(this.dataList);
        if (this.paginator) {
          this.dataSource.paginator = this.paginator;
        }

      }
    }catch(err){
      this.customMessageService.close();
      await this.customMessageService.open({
        title: 'Error', 
        type: 'error', 
        message: String(err), 
        dismissBtn: true 
      });
    }
  }
  
  public async deleteRecord(record: any, index: number){
    try{
      const deleteConfirm = await this.customMessageService.open({
        title: 'Cuidado',
        type: 'warning',
        message: `¿Seguro que quieres eliminar el registro <b>${record.name}</b> de forma permanente?`,
        acceptBtn: true,
        dismissBtn: true,
      });
  
      if (deleteConfirm) {
        this.customMessageService.close();
        this.dataList = this.dataList.filter(item => item.id !== record.id);
        this.hasData = !!this.dataList && this.dataList.length > 0;
        console.log('[getEntityData] dataList', this.dataList)
        this.dataSource = new MatTableDataSource(this.dataList);
        if (this.paginator) {
          this.dataSource.paginator = this.paginator;
        }

      }
    }catch(err){
      this.customMessageService.close();
      await this.customMessageService.open({
        title: 'Error', 
        type: 'error', 
        message: String(err), 
        dismissBtn: true 
      });
    }
  }



  /**@description Abrir diálogo de requerimientos/productos */
  async openRequirementsDialog(item: any) {
    try {
      const dialogRef = this.dialog.open(ProcedureRequirementsComponent, {
        disableClose: true,
        width: '80%',
        data: {
          procedure: item,
          contract: this.contractData,
        }
      });
      
      dialogRef.afterClosed().subscribe(async result => {
        if (result) {
          // Actualizar el procedimiento con los requerimientos
          const index = this.contractProcedures.findIndex(p => p.id === item.id);
          if (index !== -1) {
            this.contractProcedures[index].requirements = result.requirements;
          }
        }
      });
    } catch (err) {
      this.customMessageService.open({
        title: "Error", 
        message: `Ocurrió un error inesperado. ${err}`, 
        type: "error", 
        dismissBtn: true
      });
    }
  }

  /**@description Guardar todos los cambios del contrato */
  async saveChanges() {
    try {
      let response = await this.customMessageService.open({
        title: "Confirmar", 
        type: "warning", 
        message: `¿Desea guardar los cambios realizados en los procedimientos del contrato?`, 
        dismissBtn: true,
        acceptBtn: true,
        acceptBtnText: "Guardar"
      });
      
      if (!response) return;

      this.customMessageService.open({
        title: "Espere", 
        message: "Guardando cambios", 
        type: "neutral", 
        loading: true
      });

      // Preparar datos para enviar
      const dataToSave = {
        id: this.contractData.id,
        procedures: this.dataList,
        operationType:'single'
      };

      let apiResponse: any = await this.contractsService.update(dataToSave);
      this.customMessageService.close();
      
      if (apiResponse.state == "success") {
        this.customSnackBar.open(apiResponse.message, "success");
        this.dialogRef.close(true);
      } else {
        this.customSnackBar.open(apiResponse.message, "info");
      }
    } catch (err) {
      this.customMessageService.close();
      this.customMessageService.open({
        title: "Error", 
        message: `Ocurrió un error inesperado. ${err}`, 
        type: "error", 
        dismissBtn: true
      });
    }
  }

  /**@description Cerrar diálogo sin guardar */
  close() {
    if (this.dataList.length !== (this.contractData['procedures']?.length || 0)) {
      this.customMessageService.open({
        title: "Advertencia", 
        type: "warning", 
        message: `Tiene cambios sin guardar. ¿Está seguro de cerrar?`, 
        dismissBtn: true,
        acceptBtn: true,
        acceptBtnText: "Cerrar sin guardar"
      }).then(response => {
        if (response) {
          this.dialogRef.close(false);
        }
      });
    } else {
      this.dialogRef.close(false);
    }
  }

   async openUploadFile() {
      try {
        let dataFile = [];
        
        const config: ExcelUploaderConfig = {
          entityName: 'procedures',
          columns: [
            { 
              excelColumn: 'Nombre',
              objectKey: 'id',
              required: true,
              catalogMapping: {
                catalog: this.procedureList,
                nameField: 'name',
                idField: 'id'
              }
            },
            { excelColumn: 'Nombre', objectKey: 'name', required: true },
            { excelColumn: 'Partida', objectKey: 'itemNumber', required: true },
            { excelColumn: 'Precio', objectKey: 'price', required: true },
            { 
              excelColumn: 'Especialidad',
              objectKey: 'specialty',
              required: true,
              catalogMapping: {
                catalog: this.specialtyList,
                nameField: 'name',
                idField: 'id'
              }
            },
          ],
          validation: {
            targetColumn: 'name'
          },
          services: {
            uploadFileDialog: this.uploadFileDialog,
            customMessageService: this.customMessageService
          },
          search: {},  // Puedes dejarlo vacío también
          skipSave: true
        };
        
        const result = await this.simpleExcelUpload.uploadExcelFile(config);
        
        if (result) {
          dataFile = result.allItems;
    
          const idsExistentes = new Set(this.dataList.map(obj => obj.itemNumber));
          const nuevosElementos = dataFile.filter(obj => !idsExistentes.has(obj.itemNumber));
          this.dataList.push(...nuevosElementos);
          this.dataList.forEach(element =>{
            element._specialty = this.specialtyObject[element.specialty] ?? 'N/A';
          })
          
          this.dataSource = new MatTableDataSource(this.dataList);
          if (this.paginator) {
            this.dataSource.paginator = this.paginator;
          }
        }
        
      } catch (err) {
        console.error('[openUploadFile] Error:', err);
      }
    }

  /**@description Descargar archivo Excel */
  async downloadFile() {
    await this.simpleExcel.simpleXLSX({
      fileName: `${this.catalogue} - ${this.contractData.name}`,
      sheets: [
        {
          sheetName: `${this.cat}`,
          columns: this.structure,
          data: this.dataList,
          header: [
            `${this.catalogue}: ${this.contractData.name}`,
            "Epione"
          ],
          lineBreak: 1
        }
      ]
    });
  }

      /**
   * @description Download of sample file to update products
   */
  async downloadSampleFile() {
    let tableStruct: TableStructureModel[] = [];
    this.inputs.forEach(input => {
      tableStruct.push({columnKey: input.name, columnName: input.displayName, type: 'string'})
    })
    
    await this.simpleExcel.simpleXLSX({
      fileName: `Carga de Catálogo (Archivo Muestra)`,
      sheets: [
        {
          sheetName: 'Elementos',
          columns: tableStruct,
          data: [],
          header: [],
          lineBreak: 0,
        }
      ],
    });
  }
}